export default __webpack_public_path__ + "static/media/Roboto-Medium.f9f0c871.eot";